import { isDefined } from "@omni/utils/helper.utils";
import { CountryCode } from "libphonenumber-js";

import { StoreSearchStore } from "@/components/Store/StoreSearch/storeSearch.types";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { formatNextOpeningDate } from "@/utils/date";

import { useStoreSearchContext } from "../../../storeSearch.context";
import { StoreCard } from "./storeCard.component";

type StoreCardProps = {
    store: StoreSearchStore;
};

const StoreCardContainer = ({ store }: StoreCardProps) => {
    const { selectedStore } = useStoreSearchContext();
    const { t } = useGranite();

    const handleOnStoreCardClick = () => location.assign(store.url);

    const addressLines = store.properties.address.lines?.join(", ");
    const addressCity = `${store.properties.address.zipcode} ${store.properties.address.city}`;
    const addressLine = `${addressLines}, ${addressCity}`;

    const isSelected =
        isDefined(selectedStore) &&
        store.properties.user_properties.storeId ===
            selectedStore?.properties.user_properties.storeId;

    const open = store.properties.open.open_now;

    const nextOpeningDate = formatNextOpeningDate(
        store.properties.open.next_opening?.day
    );
    const nextOpeningTime = store.properties.open.next_opening?.start;

    const openClosesAt = open
        ? t(
              "form.searchstore.storeCard.status.closesAt",
              store.properties.open.current_slice.end
          )
        : nextOpeningDate && nextOpeningTime
          ? t(
                "form.searchstore.storeCard.status.opensAt",
                nextOpeningDate,
                nextOpeningTime
            )
          : undefined;

    return (
        <StoreCard
            addressLines={[addressLine]}
            countryCode={store.properties.address.country_code! as CountryCode}
            distancePromise={store.distancePromise}
            handleOnStoreCardClick={handleOnStoreCardClick}
            isSelected={isSelected}
            isOpen={open}
            openClosesAt={openClosesAt}
            name={store.properties.name}
            phone={store.properties.contact.phone}
        />
    );
};

export { StoreCardContainer };
